<mat-dialog-content class="p-0 m-0 overflow-hidden">
     <iframe width="100%" height="650px" frameborder="0" src="https://supersonic2.speedtestcustom.com"></iframe>
</mat-dialog-content>